<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
    <skl-dialog-header-ins
        [title]="viewModel.dialogTitle"
		id="client-dialog-header"
        (onClose)="onCancel()">
    </skl-dialog-header-ins>

    <ins-content>
        <skl-form-container>
            @if (viewModel.isFormReady) {
                <ins-tab-group>
                    <ins-tab-bar
                        slot="top"
                        [class]="buyerBo ? '' : 'display--none'"
                        [selectedTab]="commonAreaId">
                        <ins-tab-button
                            [tab]="commonAreaId"
                            id="sale-single-email-dialog-common-tab">
                            {{'scenes.shared.dialog.client.form.sections.basic' | translate}}
                            <skl-validation-area
                                class="align--tiny-left"
                                [areaId]="commonAreaId">
                            </skl-validation-area>
                        </ins-tab-button>
                            <ins-tab-button
                                [tab]="otherBuyerAreaId"
                                id="sale-single-email-dialog-message-tab">
                                {{'scenes.shared.dialog.client.form.sections.other-buyer' | translate}}
                                <skl-validation-area
                                    class="align--tiny-left"
                                    [areaId]="otherBuyerAreaId">
                                </skl-validation-area>
                            </ins-tab-button>
                    </ins-tab-bar>
                    <ins-tab
                        [attr.validation-area-id]="commonAreaId"
                        [tab]="commonAreaId">
                        <div class="tab-wrapper">
                            @if (viewModel.isAdjustmentMode) {
                                <div>
                                    <div class="box-label">
                                        {{'scenes.shared.dialog.client.form.sections.before-adjustment' | translate}}
                                    </div>
                                    <div class="box-content">
                                        <skl-client-dialog-form
                                            [bo]="previousBo"
                                            [previousDataMode]="true"
                                            [buyer]="viewModel.previousBuyer"
                                            [inEditMode]="viewModel.isFormInEditMode"
                                            [buyerVisible]="viewModel.buyerVisible"
                                            [supplierContext]="viewModel.supplierContext"
                                            [countries]="viewModel.countries"
                                            [previewMode]="data.previewMode"
                                            [adjustmentMode]="viewModel.isAdjustmentMode">
                                        </skl-client-dialog-form>
                                    </div>
                                </div>
                            }
                            <div>
                                @if (viewModel.isAdjustmentMode) {
                                    <div class="box-label">
                                        {{'scenes.shared.dialog.client.form.sections.after-adjustment' | translate}}
                                    </div>
                                }
                                <div class="box-content">
                                    <skl-client-dialog-form
                                        [bo]="bo"
                                        [buyer]="viewModel.buyer"
                                        [inEditMode]="viewModel.isFormInEditMode"
                                        [showValidations]="viewModel.showValidations"
                                        [buyerVisible]="viewModel.buyerVisible"
                                        [supplierContext]="viewModel.supplierContext"
                                        [countries]="viewModel.countries"
                                        [previewMode]="data.previewMode"
                                        [adjustmentMode]="viewModel.isAdjustmentMode"
                                        [goToMessage]="data.goToClientsMessages?.client"
                                        (redirectToClients)="redirectToClients(bo.model.id)">
                                    </skl-client-dialog-form>
                                </div>
                            </div>

                        </div>
                    </ins-tab>
                    @if (buyerBo) {
                        <ins-tab
                            [attr.validation-area-id]="otherBuyerAreaId"
                            [tab]="otherBuyerAreaId">
                            <div class="tab-wrapper">
                                @if (viewModel.isAdjustmentMode && previousBuyerBo) {
                                    <div>
                                        <div class="box-label">
                                            {{'scenes.shared.dialog.client.form.sections.before-adjustment' | translate}}
                                        </div>
                                        <div class="box-content">
                                            <skl-client-dialog-other-buyer-form
                                                [bo]="previousBuyerBo"
                                                [previousDataMode]="true"
                                                [countries]="viewModel.countries"
                                                [previewMode]="data.previewMode"
                                                [adjustmentMode]="viewModel.isAdjustmentMode">
                                            </skl-client-dialog-other-buyer-form>
                                        </div>
                                    </div>
                                }
                                <div>
                                    @if (viewModel.isAdjustmentMode) {
                                        <div class="box-label">
                                            {{'scenes.shared.dialog.client.form.sections.after-adjustment' | translate}}
                                        </div>
                                    }
                                    <div class="box-content">
                                        <skl-client-dialog-other-buyer-form
                                            [bo]="buyerBo"
                                            [countries]="viewModel.countries"
                                            [inEditMode]="viewModel.isFormInEditMode"
                                            [showValidations]="viewModel.showValidations"
                                            [previewMode]="data.previewMode"
                                            [adjustmentMode]="viewModel.isAdjustmentMode"
                                            [goToMessage]="data.goToClientsMessages?.buyer"
                                            (redirectToClients)="redirectToClients(buyerBo?.model?.id)">
                                        </skl-client-dialog-other-buyer-form>
                                    </div>
                                </div>
                            </div>
                        </ins-tab>
                    }
                </ins-tab-group>
            }
        </skl-form-container>
    </ins-content>
        <ins-footer>
            <ins-checkbox
                id="client-dialog-save-in-clients"
                [label]="'scenes.shared.dialog.client.form.save-in-clients' | translate"
                [disabled]="viewModel.saveInClientsDisabled"
                [(ngModel)]="viewModel.saveInClients">
            </ins-checkbox>
            <div class="dialog__buttons">
                @if (data.previewMode) {
                    <skl-button
                        id="client-dialog-close-button"
                        (click)="onCancel()">
                        {{ 'scenes.shared.dialog.client.buttons.close' | translate }}
                    </skl-button>
                }
                @else {
                    <skl-button
                        id="client-dialog-cancel-button"
                        (click)="onCancel()">
                        {{ 'scenes.shared.dialog.client.buttons.cancel' | translate }}
                    </skl-button>
                    <skl-button
                        id="client-dialog-save-button"
                        typeName="accent"
                        [spinner]="viewModel.isFormSaving"
                        (click)="saveAsync()">
                        {{ 'scenes.shared.dialog.client.buttons.save' | translate }}
                    </skl-button>
                }
            </div>
        </ins-footer>
</skl-dialog-content-ins>
